import GlobalState, {} from "../../../stores/GlobalState";
import Select, { components } from 'components/common/AppSelect'
import { observer } from 'mobx-react'

const DeploySecondPage = observer(({
        langv,
        activeexportblock1,
        activeexportblock2,
        typeDeploy,
        setActiveexportblock01,
        AttachmentBoxAnaliticsbigexport,
        attachments,
        setAttachments,
        nameDatasetprew,
        load,
        setLoad,
        DropdownIndicator,
        days,
        customStyles2,
        v1_export,
        v2_export,
        v3_export,
        v4_export,
        handleChangeEvery,
        DatePicker,
        startDate,
        polden,
        setNameDatasetprew01,
        setStartDate,
        setHour0,
        setMinut0,
        setPolden,
        PostLinkOutlineBig,
        setTextloadingcompleated,
        Loading,
        formatDate,
        changesegmentationpagecenterAll,
        changepopupCloseEditDeploy0,
        textloadingdeployexport,
        LoadingCompleted,
        textloadingcompleatedexport,
        changepopupdeleteShedule,
        setActiveexportblock02,
        setTypeDeploy,
        AttachmentBoxAnaliticsbigOnetimeexport,
        nameDatasetprew2,
        setNameDatasetprew02,
        PostLinkOutlineBigNoSchedule,
        setNameDatasetprew,
        setNameDatasetprew2,
        setTextloadingcompleatedexport,
        textloadingdeployexportonetime,
        getLinkOutline
    }) =>{
        console.log(attachments[0]?.file + "");
        
        return (
            
        <>
            <div className='export_deploy_line'>
                <div className='export_deploy_line_title' onClick={()=>setActiveexportblock01(!activeexportblock1)}>
                    Schedule
                    {
                        activeexportblock1?
                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6.84706" cy="9.46156" r="1.53846" fill="#020203"/>
                            <circle cx="6.84706" cy="9.46156" r="1.53846" fill="black" fill-opacity="0.2"/>
                            <circle cx="6.84706" cy="9.46156" r="1.53846" fill="black" fill-opacity="0.2"/>
                            <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="#020203"/>
                            <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" stroke-opacity="0.2"/>
                            <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" stroke-opacity="0.2"/>
                        </svg>
                        :
                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.0769)" fill="#020203"/>
                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.0769)" fill="black" fill-opacity="0.2"/>
                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.0769)" fill="black" fill-opacity="0.2"/>
                            <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="#020203"/>
                            <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="black" stroke-opacity="0.2"/>
                            <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="black" stroke-opacity="0.2"/>
                        </svg>
                    }
                    
                </div>
                {
                    GlobalState.segmentationpagecenter1==1?
                
                        activeexportblock1?
                        <>
                            <div className='change_type_deploy_list1'>
                                <div className='change_type_deploy_list1_first'>
                                    <label>New Big Query Table ID<star>*</star></label>
                                    <input
                                        type="text"
                                        className= {v1_export?'change_type_deploy_list1_left error':'change_type_deploy_list1_left'}
                                        value={GlobalState.portraitsheduledeployname}
                                        placeholder='Type new Big Query table ID'
                                        onChange={(e)=>setNameDatasetprew01(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <AttachmentBoxAnaliticsbigexport {...{ attachments, setAttachments, nameDatasetprew, load, setLoad }} />
                                </div>
                            </div>
                            <div className='shedule deploy'>
                                <div className='shedule_line1'>
                                    Parameters of deploy
                                </div>
                                <div className='shedule_line2'>
                                    <div className='shedule_text'>
                                        {langv?.deploy?.text31}<star>*</star>
                                    </div>
                                    <div className='shedule_line2_col2'>
                                        <input id="website" type="text" placeholder="1" class="input_every" disabled={true} style={{width: "32px", borderRadius:"8px", marginRight: "8px", border: "1px solid rgba(216, 221, 228, 1)", color: 'rgba(2, 2, 3, 0.4)'}} value={"01"} ></input>
                                    </div>
                                    <div className='shedule_line2_col3'>
                                        {
                                            GlobalState.activeportraits?.deploymentInfo!=null?
                                            <Select 
                                                components={{ DropdownIndicator }}
                                                options={days} 
                                                styles={customStyles2} 
                                                classNamePrefix='filter'
                                                className={v2_export?'selectproduct error':'selectproduct'}
                                                  
                                                placeholder="Select period"
                                                value={GlobalState.sheduleEvery}
                                                onChange={handleChangeEvery}
                                                //onChange={(option) => setEvery(option.value)}
                                            />
                                            :
                                            <Select 
                                                components={{ DropdownIndicator }}
                                                options={days} 
                                                styles={customStyles2} 
                                                classNamePrefix='filter'
                                                className={v2_export?'selectproduct error':'selectproduct'}
                                                  
                                                placeholder="Select period"
                                                //value={GlobalState.sheduleEvery}
                                                onChange={handleChangeEvery}
                                                //onChange={(option) => setEvery(option.value)}
                                            />
                                        }
                                        
                                        
                                    </div>
                                    <div className='shedule_text'>
                                        {langv?.deploy?.text32}<star>*</star>
                                    </div>
                                    <div className='shedule_line3_col2'>
                                        <DatePicker selected={startDate} minDate={new Date().toISOString().split('T')[0]} dateFormat="dd.MM.YYYY" onChange={(date) => setStartDate(date)} />
                                    </div>
                                    
                                
                                
                                    <div className='shedule_line3_col4'>
                                    {langv?.deploy?.text33}<star>*</star>
                                    </div>
                                    <div className='shedule_line3_col5'>
                                        <input type="number" placeholder="00" class={v3_export?"input_every error":"input_every"} max={23}  value={GlobalState.sheduleHour} onChange={(option) => setHour0(option.target.value)} ></input>
                                    </div>
                                    <div className='shedule_line3_col4'>
                                    {langv?.deploy?.text34}<star>*</star>
                                    </div>
                                    <div className='shedule_line3_col5'>
                                        <input type="number" placeholder="00" class={v4_export?"input_every error":"input_every"} max={59} value={GlobalState.sheduleMinute} onChange={(option) => setMinut0(option.target.value)} ></input>
                                    </div>

                                    <div className='checkpolden'>
                                        <span className={polden==1?"active":<></>} onClick={()=>setPolden(1)}>AM</span>
                                        <span className={polden==2?"active":<></>} onClick={()=>setPolden(2)}>PM</span>
                                    </div>
                                    
                                </div>
                            </div>
                            <div className='line_shedule_deploy run_predict'>
                                <div className='shedule_line_text'>
                                    <span></span>Time is indicated in UTC
                                </div>
                                <div className='button_block_deploy_edit'>
                                    {
                                        GlobalState.portraitsheduledeployname!=""&&GlobalState.sheduleEvery!=""&&GlobalState.sheduleHour!=""&&GlobalState.sheduleMinute!=""&&GlobalState.attachname!=''?
                                        <div className='but_run_predict' onClick={()=>PostLinkOutlineBig(startDate, polden, setTextloadingcompleated)}>
                                            {langv?.segmentation?.apply}
                                        </div>
                                        :
                                        <div className='but_run_predict inactive' onClick={()=>getLinkOutline_error()}>
                                            {langv?.segmentation?.apply}
                                        </div>
                                    }
                                    {
                                        
                                        GlobalState.activeportraits?.deploymentInfo!=null?
                                        <div className='but_run_predict button_border' onClick={()=>changepopupCloseEditDeploy0()}>
                                            Cancel
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>
                            </div>
                        </>
                        :
                        <></>
                    :
                    <></>
                }
                {
                    GlobalState.segmentationpagecenter1==2?
                    <div style={{marginTop:"30px", marginBottom:"30px"}}>
                        <Loading text = {textloadingdeployexport}/>
                    </div>
                    :
                    <></>
                }
                {
                    GlobalState.segmentationpagecenter1==3?
                    <div style={{marginTop:"30px", marginBottom:"30px"}}>
                        <LoadingCompleted text = {textloadingcompleatedexport}/>
                    </div>
                    :
                    <></>
                }
                {
                    GlobalState.segmentationpagecenter1==5?
                    <div style={{marginTop:"30px", marginBottom:"30px"}}>
                        <LoadingFail text = {textloadingcompleatedexport}/>
                    </div>
                    :
                    <></>
                }
                {
                    GlobalState.segmentationpagecenter1==4?
                    <div className='clasnameredactura'>
                        <div className='clasnameredactura_title'>
                            Export details
                            <span className='clasnameredactura_read'>
                                <svg onClick={()=>changesegmentationpagecenterAll()} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.3009 5.76489L5.36567 12.7006C5.15721 12.909 5.01334 13.1732 4.95135 13.4614L4.38479 16.0938C4.36941 16.1653 4.37219 16.2395 4.39286 16.3096C4.41353 16.3797 4.45145 16.4435 4.50314 16.4952C4.55483 16.5469 4.61865 16.5848 4.68877 16.6055C4.75889 16.6262 4.83307 16.629 4.90454 16.6136L7.54354 16.0448C7.83153 15.9829 8.09554 15.8392 8.30392 15.631L16.0184 7.91652C16.3988 7.52562 16.61 7.00064 16.6063 6.45518C16.6027 5.90972 16.3843 5.38765 15.9986 5.00194C15.6129 4.61623 15.0908 4.39791 14.5454 4.39421C13.9999 4.39052 13.4749 4.60175 13.084 4.9822L12.3276 5.7382L12.3009 5.76489ZM13.3934 5.29152C13.7017 4.99066 14.1162 4.82343 14.547 4.82609C14.9778 4.82874 15.3902 5.00105 15.6949 5.30569C15.9995 5.61032 16.1718 6.02273 16.1745 6.45354C16.1771 6.88434 16.0099 7.29884 15.709 7.6072L15.0944 8.22189L12.7787 5.9062L13.3934 5.29152ZM12.4685 6.21552L14.7842 8.5312L7.99417 15.3212C7.84533 15.4702 7.65665 15.573 7.45079 15.6174L4.81223 16.1861L5.37835 13.5533C5.42271 13.3474 5.52556 13.1587 5.67454 13.0099L12.4685 6.21552Z" fill="#020203"/>
                                </svg>
                                <svg onClick={()=>changepopupdeleteShedule()} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.1 5.77654H11.9C11.9 5.40524 11.7525 5.04914 11.4899 4.78659C11.2274 4.52404 10.8713 4.37654 10.5 4.37654C10.1287 4.37654 9.7726 4.52404 9.51005 4.78659C9.2475 5.04914 9.1 5.40524 9.1 5.77654ZM8.05 5.77654C8.05 5.4548 8.11337 5.13621 8.2365 4.83896C8.35962 4.54172 8.54008 4.27163 8.76759 4.04413C8.99509 3.81662 9.26518 3.63616 9.56243 3.51303C9.85967 3.38991 10.1783 3.32654 10.5 3.32654C10.8217 3.32654 11.1403 3.38991 11.4376 3.51303C11.7348 3.63616 12.0049 3.81662 12.2324 4.04413C12.4599 4.27163 12.6404 4.54172 12.7635 4.83896C12.8866 5.13621 12.95 5.4548 12.95 5.77654H16.975C17.1142 5.77654 17.2478 5.83185 17.3462 5.93031C17.4447 6.02876 17.5 6.1623 17.5 6.30154C17.5 6.44078 17.4447 6.57431 17.3462 6.67277C17.2478 6.77123 17.1142 6.82654 16.975 6.82654H16.051L15.232 15.3042C15.1692 15.9538 14.8666 16.5567 14.3834 16.9953C13.9001 17.4339 13.2708 17.6768 12.6182 17.6765H8.3818C7.7293 17.6766 7.10017 17.4337 6.61706 16.9951C6.13396 16.5565 5.83151 15.9537 5.7687 15.3042L4.949 6.82654H4.025C3.88576 6.82654 3.75223 6.77123 3.65377 6.67277C3.55531 6.57431 3.5 6.44078 3.5 6.30154C3.5 6.1623 3.55531 6.02876 3.65377 5.93031C3.75223 5.83185 3.88576 5.77654 4.025 5.77654H8.05ZM9.45 9.10154C9.45 8.9623 9.39469 8.82876 9.29623 8.73031C9.19777 8.63185 9.06424 8.57654 8.925 8.57654C8.78576 8.57654 8.65223 8.63185 8.55377 8.73031C8.45531 8.82876 8.4 8.9623 8.4 9.10154V14.3515C8.4 14.4908 8.45531 14.6243 8.55377 14.7228C8.65223 14.8212 8.78576 14.8765 8.925 14.8765C9.06424 14.8765 9.19777 14.8212 9.29623 14.7228C9.39469 14.6243 9.45 14.4908 9.45 14.3515V9.10154ZM12.075 8.57654C12.2142 8.57654 12.3478 8.63185 12.4462 8.73031C12.5447 8.82876 12.6 8.9623 12.6 9.10154V14.3515C12.6 14.4908 12.5447 14.6243 12.4462 14.7228C12.3478 14.8212 12.2142 14.8765 12.075 14.8765C11.9358 14.8765 11.8022 14.8212 11.7038 14.7228C11.6053 14.6243 11.55 14.4908 11.55 14.3515V9.10154C11.55 8.9623 11.6053 8.82876 11.7038 8.73031C11.8022 8.63185 11.9358 8.57654 12.075 8.57654ZM6.8138 15.2034C6.85156 15.5931 7.03307 15.9547 7.32296 16.2178C7.61284 16.4809 7.99032 16.6266 8.3818 16.6265H12.6182C13.0097 16.6266 13.3872 16.4809 13.677 16.2178C13.9669 15.9547 14.1484 15.5931 14.1862 15.2034L14.9968 6.82654H6.0032L6.8138 15.2034Z" fill="#FF3B30"/>
                                </svg>
                            </span>
                        </div>

                        
                        <div className='clasnameredactura_pole'>
                            Output dataset: <span>{GlobalState.portraitsheduledeployname}</span> 
                            
                        </div>
                        <div className='clasnameredactura_pole'>
                            Every: 
                            <span>
                                {
                                    GlobalState.portraitsheduledeployevery=='daily'?
                                    ' Day'
                                    :
                                    GlobalState.portraitsheduledeployevery=='monthly'?
                                    ' Month'
                                    :
                                    ' Week'
                                }
                            </span> 
                            
                        </div>
                        <div className='clasnameredactura_pole'>
                            
                            Start date: <span>{formatDate(GlobalState.portraitsheduledeploystarttime)}</span> 
                        </div>
                        <span className='clasnameredactura_read_b'>
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.97645 4.36004C4.42347 4.90488 4.00076 5.56764 3.73991 6.2988C3.47906 7.02996 3.38681 7.81062 3.47005 8.58244C3.4778 8.68612 3.44488 8.78874 3.37827 8.86855C3.31165 8.94837 3.21657 8.99912 3.11319 9.01004C3.0098 9.02096 2.90622 8.9912 2.8244 8.92706C2.74257 8.86292 2.68894 8.76945 2.67485 8.66644C2.57884 7.775 2.68546 6.87338 2.98675 6.02892C3.28805 5.18446 3.77624 4.41898 4.41485 3.78964C6.76445 1.47204 10.5549 1.50964 12.8805 3.86804C15.2061 6.22644 15.1909 10.016 12.8405 12.3336C11.7523 13.4081 10.2919 14.0218 8.76285 14.0472C8.18472 14.0578 7.60809 13.9848 7.05085 13.8304C6.94859 13.8022 6.86172 13.7345 6.80936 13.6423C6.757 13.55 6.74343 13.4407 6.77165 13.3384C6.79987 13.2362 6.86756 13.1493 6.95983 13.0969C7.0521 13.0446 7.16139 13.031 7.26365 13.0592C7.74693 13.1932 8.24704 13.2565 8.74845 13.2472C10.0725 13.2264 11.3373 12.6951 12.2789 11.764C14.3117 9.75924 14.3285 6.47604 12.3109 4.42964C10.2933 2.38324 7.00925 2.35524 4.97645 4.36004Z" fill="#8E8E93"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.37165 9.09045C3.33667 9.12964 3.29431 9.16155 3.24699 9.18437C3.19967 9.20719 3.14832 9.22046 3.09588 9.22343C3.04343 9.2264 2.99091 9.21902 2.94132 9.20169C2.89173 9.18436 2.84604 9.15744 2.80685 9.12245L1.43085 7.89845C1.38855 7.8645 1.3536 7.82229 1.32812 7.77441C1.30264 7.72652 1.28717 7.67395 1.28264 7.6199C1.27812 7.56585 1.28463 7.51144 1.30179 7.45998C1.31895 7.40853 1.3464 7.3611 1.38246 7.32058C1.41853 7.28006 1.46245 7.2473 1.51157 7.22429C1.56069 7.20129 1.61398 7.18851 1.66819 7.18674C1.72241 7.18497 1.77642 7.19424 1.82693 7.214C1.87745 7.23375 1.92342 7.26357 1.96205 7.30165L3.33805 8.52565C3.37735 8.56053 3.4094 8.6028 3.43235 8.65006C3.45531 8.69732 3.46874 8.74864 3.47186 8.80109C3.47498 8.85354 3.46773 8.90609 3.45054 8.95574C3.43335 9.00539 3.40654 9.05117 3.37165 9.09045Z" fill="#8E8E93"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.75188 9.04007C2.78339 9.0821 2.82288 9.1175 2.86808 9.14426C2.91328 9.17103 2.96331 9.18862 3.01531 9.19605C3.06731 9.20348 3.12026 9.2006 3.17115 9.18756C3.22203 9.17452 3.26985 9.15159 3.31188 9.12007L4.91188 7.92007C4.99675 7.85642 5.05285 7.76166 5.06786 7.65664C5.08286 7.55162 5.05553 7.44494 4.99188 7.36007C4.92822 7.2752 4.83347 7.2191 4.72845 7.20409C4.62342 7.18909 4.51675 7.21642 4.43188 7.28007L2.83188 8.48007C2.74701 8.54373 2.6909 8.63848 2.6759 8.7435C2.66089 8.84852 2.68822 8.9552 2.75188 9.04007ZM8.49588 5.20007C8.60196 5.20007 8.70371 5.24222 8.77872 5.31723C8.85373 5.39225 8.89588 5.49399 8.89588 5.60007V8.40007C8.89588 8.50616 8.85373 8.6079 8.77872 8.68292C8.70371 8.75793 8.60196 8.80007 8.49588 8.80007C8.38979 8.80007 8.28805 8.75793 8.21303 8.68292C8.13802 8.6079 8.09588 8.50616 8.09588 8.40007V5.60007C8.09588 5.49399 8.13802 5.39225 8.21303 5.31723C8.28805 5.24222 8.38979 5.20007 8.49588 5.20007Z" fill="#8E8E93"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2938 8.4C11.2938 8.50609 11.2516 8.60783 11.1766 8.68284C11.1016 8.75786 10.9998 8.8 10.8937 8.8H8.49375C8.38766 8.8 8.28592 8.75786 8.21091 8.68284C8.13589 8.60783 8.09375 8.50609 8.09375 8.4C8.09375 8.29391 8.13589 8.19217 8.21091 8.11716C8.28592 8.04214 8.38766 8 8.49375 8H10.8937C10.9998 8 11.1016 8.04214 11.1766 8.11716C11.2516 8.19217 11.2938 8.29391 11.2938 8.4Z" fill="#8E8E93"/>
                            </svg>
                            
                            {
                                GlobalState.portraitsheduledeploydata?
                                formatDate(GlobalState.portraitsheduledeploydata)
                                :
                                formatDate(new Date())
                            }
                            
                        </span>
                    </div>
                    :
                    <></>
                }
            </div>

            <div className='export_deploy_line'>
                <div className='export_deploy_line_title'  onClick={()=>setActiveexportblock02(!activeexportblock2)}>
                    One-time export
                    {
                        activeexportblock2?
                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="6.84706" cy="9.46156" r="1.53846" fill="#020203"/>
                            <circle cx="6.84706" cy="9.46156" r="1.53846" fill="black" fill-opacity="0.2"/>
                            <circle cx="6.84706" cy="9.46156" r="1.53846" fill="black" fill-opacity="0.2"/>
                            <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="#020203"/>
                            <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" stroke-opacity="0.2"/>
                            <path d="M0.691406 7.15385L7.03173 1L12.9991 7.15385" stroke="black" stroke-opacity="0.2"/>
                        </svg>
                        :
                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.0769)" fill="#020203"/>
                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.0769)" fill="black" fill-opacity="0.2"/>
                            <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.0769)" fill="black" fill-opacity="0.2"/>
                            <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="#020203"/>
                            <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="black" stroke-opacity="0.2"/>
                            <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="black" stroke-opacity="0.2"/>
                        </svg>
                    }
                </div>
                {
                    activeexportblock2?
                
                    <div className='change_type_deploy'>
                        <div className='single_type_deploy' onClick={()=>setTypeDeploy(1)}>
                            {
                                typeDeploy==1?
                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="9" cy="10" r="4" fill="#33A753"/>
                                    <path d="M8 1.57735C8.6188 1.22008 9.3812 1.22008 10 1.57735L15.7942 4.92265C16.413 5.27992 16.7942 5.94017 16.7942 6.6547L16.7942 13.3453C16.7942 14.0598 16.413 14.7201 15.7942 15.0774L10 18.4226C9.3812 18.7799 8.6188 18.7799 8 18.4226L2.20577 15.0774C1.58697 14.7201 1.20577 14.0598 1.20577 13.3453L1.20577 6.6547C1.20577 5.94017 1.58697 5.27992 2.20577 4.92265L8 1.57735Z" stroke="#33A753" stroke-width="1.5"/>
                                </svg>
                                :
                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1.57735C8.6188 1.22008 9.3812 1.22008 10 1.57735L15.7942 4.92265C16.413 5.27992 16.7942 5.94017 16.7942 6.6547L16.7942 13.3453C16.7942 14.0598 16.413 14.7201 15.7942 15.0774L10 18.4226C9.3812 18.7799 8.6188 18.7799 8 18.4226L2.20577 15.0774C1.58697 14.7201 1.20577 14.0598 1.20577 13.3453L1.20577 6.6547C1.20577 5.94017 1.58697 5.27992 2.20577 4.92265L8 1.57735Z" stroke="#1C1E20" stroke-width="1.5"/>
                                </svg>
                            }
                            <span>{langv?.segmentation?.new_big_query_table_ID}</span>
                        </div>
                        {
                            
                            GlobalState.segmentationpagecenter2==1?
                                typeDeploy==1?
                                <>
                                <div className='change_type_deploy_list1'>
                                    <div className='change_type_deploy_list1_first'>
                                        <label>New Big Query Table ID<star>*</star></label>
                                        <input
                                            type="text"
                                            className= {v1_export?'change_type_deploy_list1_left error':'change_type_deploy_list1_left'}
                                            value={GlobalState.portraitsheduledeployname2}
                                            placeholder='Type New Big Query Table ID'
                                            onChange={(e)=>setNameDatasetprew02(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <AttachmentBoxAnaliticsbigOnetimeexport {...{ attachments, setAttachments, nameDatasetprew2, load, setLoad }} />
                                    </div>
                                    
                                </div>
                                <div className='line_shedule_deploy run_predict' style={{marginTop: "20px", marginBottom: "30px"}}>
                                    <div className='shedule_line_text'>
                                    
                                    </div>
                                    {
                                        nameDatasetprew2!=""?
                                        <div className='but_run_predict' onClick={()=> PostLinkOutlineBigNoSchedule(setNameDatasetprew, setNameDatasetprew2, setTypeDeploy, setTextloadingcompleatedexport)}>
                                            {langv?.segmentation?.apply}
                                        </div>
                                        :
                                        <div className='but_run_predict inactive' onClick={()=>getLinkOutline_error()}>
                                            {langv?.segmentation?.apply}
                                        </div>
                                    }
                                    
                                </div>
                                </>
                                :
                                <></>
                                :
                            <></>
                        }
                        {
                            GlobalState.segmentationpagecenter2==2?
                            <div style={{marginTop:"30px", marginBottom:"30px", minWidth: "100%"}}>
                                <Loading text = {textloadingdeployexportonetime}/>
                            </div>
                            :
                            <></>
                        }
                        {
                            GlobalState.segmentationpagecenter2==3?
                            <div style={{marginTop:"30px", marginBottom:"30px", minWidth: "100%"}}>
                                <LoadingCompleted text = {textloadingcompleatedexport}/>
                            </div>
                            :
                            <></>
                        }
                        {
                            GlobalState.segmentationpagecenter2==4?
                            <div style={{marginTop:"30px", marginBottom:"30px", minWidth: "100%"}}>
                                <LoadingFail text = {textloadingcompleatedexport}/>
                            </div>
                            :
                            <></>
                        }
                        
                        <div className='single_type_deploy' onClick={()=>setTypeDeploy(3)}>
                            {
                                typeDeploy==3?
                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="9" cy="10" r="4" fill="#33A753"/>
                                    <path d="M8 1.57735C8.6188 1.22008 9.3812 1.22008 10 1.57735L15.7942 4.92265C16.413 5.27992 16.7942 5.94017 16.7942 6.6547L16.7942 13.3453C16.7942 14.0598 16.413 14.7201 15.7942 15.0774L10 18.4226C9.3812 18.7799 8.6188 18.7799 8 18.4226L2.20577 15.0774C1.58697 14.7201 1.20577 14.0598 1.20577 13.3453L1.20577 6.6547C1.20577 5.94017 1.58697 5.27992 2.20577 4.92265L8 1.57735Z" stroke="#33A753" stroke-width="1.5"/>
                                </svg>
                                :
                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1.57735C8.6188 1.22008 9.3812 1.22008 10 1.57735L15.7942 4.92265C16.413 5.27992 16.7942 5.94017 16.7942 6.6547L16.7942 13.3453C16.7942 14.0598 16.413 14.7201 15.7942 15.0774L10 18.4226C9.3812 18.7799 8.6188 18.7799 8 18.4226L2.20577 15.0774C1.58697 14.7201 1.20577 14.0598 1.20577 13.3453L1.20577 6.6547C1.20577 5.94017 1.58697 5.27992 2.20577 4.92265L8 1.57735Z" stroke="#1C1E20" stroke-width="1.5"/>
                                </svg>
                            }
                            <span>{langv?.segmentation?.oneTime_CSV}</span>
                        </div>
                        {
                            typeDeploy==3?
                            <div className='run_predict'>
                                <div className='but_run_predict' onClick={()=>getLinkOutline()}>
                                    Download
                                </div>
                            </div>
                            :
                            <></>
                        }
                        
                    </div>
                    :
                    <></>
                }
            </div>
        </>
        )
    }
)

export default DeploySecondPage;